import React from "react";
import "./Loader.css"

// Defining a functional component called 'Loader'
function Loader() {
  return (
    <>
    <div className="loader-container">
        <div className="dots"></div>
    </div>
    </>
  );
}

export default Loader;
